// @vite-ignore-fast-refresh
import {createContext} from "react";

export const ErrorContext = createContext({
    errors: [],
    setErrors: () => {},
    getErrors: () => {},
})

let expired = false

function getExpired() {
    return expired
}

function setExpired(value: boolean) {
    expired = value
}

export {getExpired, setExpired}